import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const Ctx = createContext({});

export const useContent = () => useContext(Ctx);

export const ContentProvider = ({ children }) => {
  const [content, setContent] = useState({});

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/api/content`)
      .then((r) => setContent(r.data))
      .catch(() => {});
  }, []);

  return <Ctx.Provider value={content}>{children}</Ctx.Provider>;
};
